import { registerQuery } from 'data-fetching-client';

/* @ts-expect-error module is untyped */
import AppInstallability from 'ecosystem-marketplace-core/records/AppInstallability';

/* @ts-expect-error module is untyped */
import * as ecosystemClient from '../clients/ecosystemClient';
export const GET_INSTALLABILITY = registerQuery({
  fieldName: 'installability',
  args: ['offeringId'],
  fetcher({
    offeringId
  }) {
    return ecosystemClient.fetchInstallability(offeringId).then(data => new AppInstallability(data));
  }
});